import API from "@/lib/api";

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) {
    console.log("Service Worker not supported");
    return null;
  }
  try {
    const registration = await navigator.serviceWorker.register("/sw.js");
    return registration;
  } catch (err) {
    console.error("SW registration failed:", err);
    return null;
  }
}

export async function subscribeToPush() {
  if (!("PushManager" in window)) {
    console.log("Push notifications not supported");
    return null;
  }
  if (!VAPID_PUBLIC_KEY) {
    console.log("VAPID public key not configured");
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    
    // Check existing subscription
    let subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      // Always re-send existing subscription to backend to keep it fresh
      await sendSubscriptionToBackend(subscription);
      return subscription;
    }

    // Request permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Notification permission denied");
      return null;
    }

    // Subscribe
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });

    // Send to backend
    await sendSubscriptionToBackend(subscription);
    return subscription;
  } catch (err) {
    console.error("Push subscription failed:", err);
    return null;
  }
}

export async function resubscribeToPush() {
  if (!("PushManager" in window) || !VAPID_PUBLIC_KEY) return null;
  try {
    const registration = await navigator.serviceWorker.ready;
    // Unsubscribe old
    const existing = await registration.pushManager.getSubscription();
    if (existing) {
      const oldEndpoint = existing.endpoint;
      await existing.unsubscribe();
      // Remove old from backend
      try { await API.post("/push/unsubscribe", { endpoint: oldEndpoint }); } catch {}
    }
    // Create fresh subscription
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
    await sendSubscriptionToBackend(subscription);
    return subscription;
  } catch (err) {
    console.error("Push resubscribe failed:", err);
    return null;
  }
}

export async function unsubscribeFromPush() {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      const endpoint = subscription.endpoint;
      await subscription.unsubscribe();
      // Remove from backend
      await API.post("/push/unsubscribe", { endpoint });
    }
  } catch (err) {
    console.error("Unsubscribe failed:", err);
  }
}

async function sendSubscriptionToBackend(subscription) {
  try {
    const sub = subscription.toJSON();
    await API.post("/push/subscribe", {
      endpoint: sub.endpoint,
      keys: sub.keys,
    });
  } catch (err) {
    console.error("Failed to send subscription to server:", err);
  }
}

export function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function getPushPermissionState() {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission; // "granted", "denied", "default"
}
